import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { BOILER_UPGRADE_SCHEME_FAQS } from "@/data/landing/boiler-upgrade-scheme-content";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpBoilerUpgradeSchemePage = lazyNamed(
  () => import("@/components/landing/lp-boiler-upgrade-scheme"),
  "LpBoilerUpgradeScheme",
);

const PATH = "/boiler-upgrade-scheme";
const TITLE =
  "Boiler Upgrade Scheme South Wales | £7,500 Heat Pump Grant | CRS Energy";
const DESCRIPTION =
  "Check if you qualify for a £7,500 Boiler Upgrade Scheme grant (up to £9,000 for oil & LPG homes from 21 July 2026). Book a free home energy survey for heat pumps, solar and battery storage across South Wales.";

export const Route = createFileRoute("/boiler-upgrade-scheme")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Boiler Upgrade Scheme",
        description: DESCRIPTION,
        serviceType: "Boiler Upgrade Scheme",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: BOILER_UPGRADE_SCHEME_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpBoilerUpgradeSchemePage,
});
